import { Link, useParams } from 'react-router-dom';

import { fetchInsight } from '../api/client';
import ArticleBody from '../components/ArticleBody';
import CtaBand from '../components/CtaBand';
import { useApi } from '../hooks/useApi';
import { usePageMeta } from '../hooks/usePageMeta';
import { useLanguage } from '../i18n/LanguageProvider';

export default function InsightPage() {
  const { slug = '' } = useParams();
  const { language, t } = useLanguage();
  const insight = useApi(`insight-${slug}-${language}`, (signal) =>
    fetchInsight(slug, language, signal)
  );

  usePageMeta(
    insight.status === 'ready' ? insight.data.title : t.insight.metaFallbackTitle,
    insight.status === 'ready' ? insight.data.excerpt : t.insight.metaFallbackDescription
  );

  if (insight.status === 'loading') {
    return (
      <section className="section">
        <div className="state" role="status">
          {t.insight.loading}
        </div>
      </section>
    );
  }

  if (insight.status === 'error') {
    return (
      <section className="section">
        <h1>{t.insight.notFoundTitle}</h1>
        <p className="lead" style={{ marginTop: 20 }}>
          {t.insight.notFoundText}
        </p>
        <p style={{ marginTop: 28 }}>
          <Link className="button primary" to="/insights">
            {t.insight.notFoundLink}
          </Link>
        </p>
      </section>
    );
  }

  const article = insight.data;

  return (
    <>
      <section className="page-hero">
        <p className="eyebrow">{article.topic}</p>
        <h1>{article.title}</h1>
        <p className="article-meta">
          {article.date} · {article.readingTime} {t.insight.readingSuffix}
        </p>
      </section>

      <article className="article">
        <ArticleBody blocks={article.body} />

        <div className="article-cta">
          <p className="eyebrow">{t.insight.nextStep}</p>
          <h2>{t.insight.nextStepTitle}</h2>
          <p>
            {article.relatedCaseId && article.relatedCaseTitle && (
              <>
                {t.insight.relatedCase}{' '}
                <Link className="textlink" to={`/case#${article.relatedCaseId}`}>
                  {article.relatedCaseTitle}
                </Link>
                <br />
              </>
            )}
            {article.relatedServiceId && article.relatedServiceTitle && (
              <>
                {t.insight.relatedService}{' '}
                <Link className="textlink" to={`/tjanster#${article.relatedServiceId}`}>
                  {article.relatedServiceTitle}
                </Link>
              </>
            )}
          </p>
          <p style={{ marginTop: 24 }}>
            <Link className="button primary" to="/kontakt">
              {t.insight.cta}
            </Link>
          </p>
        </div>
      </article>

      <CtaBand />
    </>
  );
}
